var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',{class:{ 'TileData__highlighted': _vm.highlight }},_vm._l((_vm.nrOfColumns),function(column){return _c('td',{key:column,class:[{'text-center': column > 1}, { 'd-flex': column === 1 }],style:(`width: ${column === 1 ? '70px' : '50px'}`)},[_vm._t(`${_vm.columns[column]}-column`)],2)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }